let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("hSDOf")).then(() => parcelRequire('6MF4v'));